import React, { useEffect, useMemo, useRef, useState } from 'react'
import Customupload from '../../components/UploadFile'
import Custompreviewimg from '../../components/PreviewUser'
import Style from './upload.module.scss'
import { RcFile } from 'antd/lib/upload'
import { message, Popover, Space, Tooltip, Typography } from 'antd'
import { generateRegExp } from '../../tools/util'
import imgUpload from '../../assets/img/icon_upload.png'
import CustomIcon from '../../components/IconUser'
import { UPLOAD_FILES_NO_SAVE } from '../../api/orderManage'
import CustomReactDndProvider from '@/components/providers/CustomReactDndProvider'
import { useDrag, useDrop } from 'react-dnd'
import clsx from 'clsx'
import { generateUUID } from '@xhgj/xh-jsutils'
import { AiKoutuButton } from '@/components/AiKoutuButton'
import { AiPsButton } from '@/components/AiPsButton'
import { HTTP } from '@/api/http'
import { AiFaceBlurButton } from '@/components/AiFaceBlurButton'
import DetailStyle from './detail.module.scss'

// 接受文件类型
const ACCEPT_FILE_TYPE = '.jpeg,.gif,.jpg,.png'

export interface imgFile {
  url: string
  name?: string
  baseUrl: string
  disabled?: boolean // 是否禁止修改/删除
}

interface Props {
  dataSource: imgFile[]
  onChange: (e: imgFile[]) => void
  disable?: boolean
  code?: string
  tempCode?: string
  isDetailPic?: boolean // 详情图
  maxCount?: number // 可上传的数量
  fileType?: string
  dragable?: boolean // 是否可拖拽
  aiEdit?: boolean // 是否开启AI编辑
  aiAuditErrorReasonForField?: any
}

interface ImageItemProps {
  item: imgFile
  index: number
  onClickPreview?: (index: number) => void
  disable?: boolean
  onClickDel?: (url: string) => void
  onInsertData?: (data: DragData, index: number) => void
  dragable?: boolean // 是否可拖拽
  componentID: string
}

interface DragData {
  item: imgFile
  index: number
}

export function getOriginImageUrl(imageInfo: any) {
  if (!imageInfo) {
    return ''
  }
  if (!imageInfo?.url?.startsWith('h')) {
    return imageInfo?.baseUrl + imageInfo?.url
  }
  return imageInfo?.url
}

export function ImageItem(props: ImageItemProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    item,
    index,
    onClickPreview,
    disable,
    onClickDel,
    onInsertData,
    dragable,
    componentID,
  } = props
  const itemRef = useRef(null)
  const [{ isDragging, dragIndex }, drag] = useDrag<
    DragData,
    any,
    { isDragging: boolean; dragIndex: number }
  >({
    type: 'ImgItem' + componentID,
    item: {
      item,
      index,
    },
    canDrag: dragable === true,
    collect(monitor) {
      return {
        isDragging: monitor.isDragging(),
        dragIndex: monitor.getItem()?.index ?? -1,
      }
    },
  })
  const [{ isOver, dropIndex }, drop] = useDrop({
    accept: 'ImgItem' + componentID,
    //   可以在drop时触发交换
    drop(data: DragData) {
      onInsertData?.(data, index)
    },
    collect(monitor) {
      return {
        isOver: monitor.isOver(),
        dropIndex: index,
      }
    },
    //   也可以在hover时触发交换
    // hover(item: imgFile) {
    //   console.log({ item })

    //   // swapIndex(index, item.index)
    //   // item.index = index
    // },
  })
  useEffect(() => {
    drag(itemRef)
    drop(itemRef)
  }, [])

  return (
    <div
      className={clsx(
        Style.fileimgitem,
        isDragging && Style.dragging,
        isOver && dropIndex < dragIndex && Style['drag-over-left'],
        isOver && dropIndex > dragIndex && Style['drag-over-right'],
      )}
      ref={itemRef}
    >
      <div className={Style.fileimgiteminfo}>
        <img
          src={getOriginImageUrl(item) + '?v=' + Date.now()}
          alt={item.name}
        />

        <div className={Style.filehide} onClick={() => onClickPreview?.(index)}>
          <div style={{ color: '#FFFFFF' }}>点击预览</div>
        </div>
        {disable || item.disabled ? null : (
          <CustomIcon
            type="icon-shanchu1"
            onClick={() => onClickDel?.(item.url)}
            className={Style.delicon}
          />
        )}
      </div>
    </div>
  )
}
// 上传文件
const Uploadimg = (props: Props) => {
  const {
    dataSource,
    onChange,
    disable,
    isDetailPic,
    tempCode,
    maxCount = 20,
    fileType,
    dragable,
    aiEdit,
    aiAuditErrorReasonForField,
  } = props
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })

  const componentIDMemo = useMemo(() => {
    return generateUUID()
  }, [])
  // 删除图片
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.url !== index)
    onChange(arr)
  }

  // 预览图片
  const onClickPreview = (cur: number) => {
    const arr = dataSource.map(
      (item) => getOriginImageUrl(item) + '?v=' + Date.now(),
    )

    setPreviewimg({
      data: arr,
      currentIndex: cur,
    })
  }

  const uploadimg = async (tempCode: string, file: RcFile[]) => {
    const resData = await UPLOAD_FILES_NO_SAVE(
      {
        type: isDetailPic ? 'detailsPicture' : 'mainPicture',
        code: tempCode,
      },
      file,
    )
    if (resData.code === 0) {
      const list = resData.data
      message.success('上传成功')
      const arr = dataSource.concat(list)
      onChange(arr)
    }
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = async (file: RcFile, FileList: RcFile[]) => {
    const fileTypeReg = generateRegExp(fileType ?? ACCEPT_FILE_TYPE)
    if (FileList.length + dataSource.length > maxCount) {
      message.error(
        isDetailPic
          ? `详情图最多上传${maxCount}张`
          : `主图最多上传${maxCount}张`,
      )
      top = 0
      return false
    }
    if (file.size > 1024 * 1024 * 2) {
      message.error('上传失败：图片大于2m')
      top = 0
      return false
    }
    if (file.name.search(fileTypeReg) === -1) {
      if (fileType) {
        message.error('图片类型不支持')
      } else {
        message.error('上传失败：请上传正确的图片格式！')
      }
      top = 0
      return false
    }
    if (fileType || isDetailPic) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      await new Promise((resolve: (str: string) => void, reject) => {
        reader.onload = () => {
          const img = new Image()
          img.onload = () => {
            if (isDetailPic && img.width < 500) {
              message.error('详情图宽度不能小于500 px')
              reject()
              return
            }
            if (!isDetailPic && (img.width < 500 || img.height < 500)) {
              message.error('请按照图片要求尺寸上传')
              reject()
              return
            }
            resolve('')
          }
          img.src = reader.result as string
        }
        reader.onerror = () => {
          reject('打开失败')
        }
      })
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      uploadimg(tempCode ? tempCode : '', FileList)
      top = 0
    }
    return false
  }
  function handleInsertData(data: DragData, dropIndex: number) {
    // if (dataSource.length < 2) {
    //   return
    // }
    const dragIndex = data.index
    // 移除原来的元素
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dataSource[data.index] = null
    if (dragIndex >= dropIndex) {
      dataSource.splice(dropIndex, 0, data.item)
    } else {
      dataSource.splice(dropIndex + 1, 0, data.item)
    }

    const newData = dataSource.filter((item) => item !== null)
    onChange(newData)
  }

  function saveImage(oldInfo: any, newInfo: any) {
    const newData = dataSource?.map((item) => {
      if (item.url && item.url === oldInfo.url) {
        return {
          ...item,
          url: newInfo.url,
        }
      }
      return item
    })
    onChange?.(newData)
  }

  return (
    <CustomReactDndProvider>
      <div className={Style.fileimgbox}>
        <div className={Style.fileimglist}>
          {dataSource.map((item, index) => {
            const key = isDetailPic
              ? item?.url
              : `${item?.baseUrl ? item?.baseUrl : HTTP}${item?.url}`
            const originImgUrl = getOriginImageUrl(item)
            const imageItem = (
              <ImageItem
                item={item}
                index={index}
                key={item.url}
                onClickDel={onClickDel}
                onClickPreview={onClickPreview}
                onInsertData={handleInsertData}
                dragable={dataSource.length > 1 && dragable}
                disable={disable}
                componentID={componentIDMemo}
              />
            )
            if (aiEdit) {
              return (
                <Popover
                  getPopupContainer={() => document.body}
                  content={
                    <Space>
                      <AiKoutuButton
                        originImgUrl={originImgUrl}
                        imageInfo={item}
                        // productCode={productCode}
                        onSaveKoutu={async (oldUrl, newUrl, options) => {
                          const { oldInfo, newInfo } = options
                          saveImage(oldInfo, newInfo)
                        }}
                      ></AiKoutuButton>
                      <AiPsButton
                        originImgUrl={originImgUrl}
                        imageInfo={item}
                        // productCode={productCode}
                        onSave={async (newInfo) => {
                          await saveImage(item, newInfo)
                        }}
                      ></AiPsButton>
                      <AiFaceBlurButton
                        originImgUrl={originImgUrl}
                        imageInfo={item}
                        // productCode={productCode}
                        onSaveFaceBlur={async (oldUrl, newUrl, options) => {
                          const { oldInfo, newInfo } = options
                          saveImage(oldInfo, newInfo)
                        }}
                        type={isDetailPic ? 'detailsPicture' : 'mainPicture'}
                      ></AiFaceBlurButton>
                    </Space>
                  }
                  key={key}
                  placement="top"
                >
                  <div className="w-[80px]"></div>
                  {imageItem}
                </Popover>
              )
            }
            return imageItem
          })}
          {disable || dataSource.length >= maxCount ? null : (
            <Customupload
              accept={fileType ?? ACCEPT_FILE_TYPE}
              multiple
              uploadBtn={
                <div
                  className={Style.uploadBtn}
                  style={{ backgroundImage: `url(${imgUpload})` }}
                ></div>
              }
              beforeUpload={(a, b) => beforeUpload(a, b)}
              visibleFile={false}
            />
          )}

          <Custompreviewimg
            onClose={() =>
              setPreviewimg({
                data: [],
              })
            }
            images={previewimg}
          />
        </div>
        <Tooltip
          placement="top"
          title={aiAuditErrorReasonForField?.join('\n')}
          overlayClassName={DetailStyle['custom-tooltip']}
          getPopupContainer={() => document.body}
        >
          {aiAuditErrorReasonForField?.map((i: any, index: number) => (
            <Typography.Text style={{ color: '#F57F17' }} ellipsis key={index}>
              {i}
            </Typography.Text>
          ))}
        </Tooltip>
      </div>
    </CustomReactDndProvider>
  )
}

export default Uploadimg
import React, { useEffect, useMemo, useRef, useState } from 'react'
import Customupload from '../../components/UploadFile'
import Custompreviewimg from '../../components/PreviewUser'
import Style from './upload.module.scss'
import { RcFile } from 'antd/lib/upload'
import { message, Popover, Space, Tooltip, Typography } from 'antd'
import { generateRegExp } from '../../tools/util'
import imgUpload from '../../assets/img/icon_upload.png'
import CustomIcon from '../../components/IconUser'
import { UPLOAD_FILES_NO_SAVE } from '../../api/orderManage'
import CustomReactDndProvider from '@/components/providers/CustomReactDndProvider'
import { useDrag, useDrop } from 'react-dnd'
import clsx from 'clsx'
import { generateUUID } from '@xhgj/xh-jsutils'
import { AiKoutuButton } from '@/components/AiKoutuButton'
import { AiPsButton } from '@/components/AiPsButton'
import { HTTP } from '@/api/http'
import { AiFaceBlurButton } from '@/components/AiFaceBlurButton'
import DetailStyle from './detail.module.scss'

// 接受文件类型
const ACCEPT_FILE_TYPE = '.jpeg,.gif,.jpg,.png'

export interface imgFile {
  url: string
  name?: string
  baseUrl: string
  disabled?: boolean // 是否禁止修改/删除
}

interface Props {
  dataSource: imgFile[]
  onChange: (e: imgFile[]) => void
  disable?: boolean
  code?: string
  tempCode?: string
  isDetailPic?: boolean // 详情图
  maxCount?: number // 可上传的数量
  fileType?: string
  dragable?: boolean // 是否可拖拽
  aiEdit?: boolean // 是否开启AI编辑
  aiAuditErrorReasonForField?: any
}

interface ImageItemProps {
  item: imgFile
  index: number
  onClickPreview?: (index: number) => void
  disable?: boolean
  onClickDel?: (url: string) => void
  onInsertData?: (data: DragData, index: number) => void
  dragable?: boolean // 是否可拖拽
  componentID: string
}

interface DragData {
  item: imgFile
  index: number
}

export function getOriginImageUrl(imageInfo: any) {
  if (!imageInfo) {
    return ''
  }
  if (!imageInfo?.url?.startsWith('h')) {
    return imageInfo?.baseUrl + imageInfo?.url
  }
  return imageInfo?.url
}

export function ImageItem(props: ImageItemProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    item,
    index,
    onClickPreview,
    disable,
    onClickDel,
    onInsertData,
    dragable,
    componentID,
  } = props
  const itemRef = useRef(null)
  const [{ isDragging, dragIndex }, drag] = useDrag<
    DragData,
    any,
    { isDragging: boolean; dragIndex: number }
  >({
    type: 'ImgItem' + componentID,
    item: {
      item,
      index,
    },
    canDrag: dragable === true,
    collect(monitor) {
      return {
        isDragging: monitor.isDragging(),
        dragIndex: monitor.getItem()?.index ?? -1,
      }
    },
  })
  const [{ isOver, dropIndex }, drop] = useDrop({
    accept: 'ImgItem' + componentID,
    //   可以在drop时触发交换
    drop(data: DragData) {
      onInsertData?.(data, index)
    },
    collect(monitor) {
      return {
        isOver: monitor.isOver(),
        dropIndex: index,
      }
    },
    //   也可以在hover时触发交换
    // hover(item: imgFile) {
    //   console.log({ item })

    //   // swapIndex(index, item.index)
    //   // item.index = index
    // },
  })
  useEffect(() => {
    drag(itemRef)
    drop(itemRef)
  }, [])

  return (
    <div
      className={clsx(
        Style.fileimgitem,
        isDragging && Style.dragging,
        isOver && dropIndex < dragIndex && Style['drag-over-left'],
        isOver && dropIndex > dragIndex && Style['drag-over-right'],
      )}
      ref={itemRef}
    >
      <div className={Style.fileimgiteminfo}>
        <img
          src={getOriginImageUrl(item) + '?v=' + Date.now()}
          alt={item.name}
        />

        <div className={Style.filehide} onClick={() => onClickPreview?.(index)}>
          <div style={{ color: '#FFFFFF' }}>点击预览</div>
        </div>
        {disable || item.disabled ? null : (
          <CustomIcon
            type="icon-shanchu1"
            onClick={() => onClickDel?.(item.url)}
            className={Style.delicon}
          />
        )}
      </div>
    </div>
  )
}
// 上传文件
const Uploadimg = (props: Props) => {
  const {
    dataSource,
    onChange,
    disable,
    isDetailPic,
    tempCode,
    maxCount = 20,
    fileType,
    dragable,
    aiEdit,
    aiAuditErrorReasonForField,
  } = props
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })

  const componentIDMemo = useMemo(() => {
    return generateUUID()
  }, [])
  // 删除图片
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.url !== index)
    onChange(arr)
  }

  // 预览图片
  const onClickPreview = (cur: number) => {
    const arr = dataSource.map(
      (item) => getOriginImageUrl(item) + '?v=' + Date.now(),
    )

    setPreviewimg({
      data: arr,
      currentIndex: cur,
    })
  }

  const uploadimg = async (tempCode: string, file: RcFile[]) => {
    const resData = await UPLOAD_FILES_NO_SAVE(
      {
        type: isDetailPic ? 'detailsPicture' : 'mainPicture',
        code: tempCode,
      },
      file,
    )
    if (resData.code === 0) {
      const list = resData.data
      message.success('上传成功')
      const arr = dataSource.concat(list)
      onChange(arr)
    }
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = async (file: RcFile, FileList: RcFile[]) => {
    const fileTypeReg = generateRegExp(fileType ?? ACCEPT_FILE_TYPE)
    if (FileList.length + dataSource.length > maxCount) {
      message.error(
        isDetailPic
          ? `详情图最多上传${maxCount}张`
          : `主图最多上传${maxCount}张`,
      )
      top = 0
      return false
    }
    if (file.size > 1024 * 1024 * 2) {
      message.error('上传失败：图片大于2m')
      top = 0
      return false
    }
    if (file.name.search(fileTypeReg) === -1) {
      if (fileType) {
        message.error('图片类型不支持')
      } else {
        message.error('上传失败：请上传正确的图片格式！')
      }
      top = 0
      return false
    }
    if (fileType || isDetailPic) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      await new Promise((resolve: (str: string) => void, reject) => {
        reader.onload = () => {
          const img = new Image()
          img.onload = () => {
            if (isDetailPic && img.width < 500) {
              message.error('详情图宽度不能小于500 px')
              reject()
              return
            }
            if (!isDetailPic && (img.width < 500 || img.height < 500)) {
              message.error('请按照图片要求尺寸上传')
              reject()
              return
            }
            resolve('')
          }
          img.src = reader.result as string
        }
        reader.onerror = () => {
          reject('打开失败')
        }
      })
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      uploadimg(tempCode ? tempCode : '', FileList)
      top = 0
    }
    return false
  }
  function handleInsertData(data: DragData, dropIndex: number) {
    // if (dataSource.length < 2) {
    //   return
    // }
    const dragIndex = data.index
    // 移除原来的元素
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dataSource[data.index] = null
    if (dragIndex >= dropIndex) {
      dataSource.splice(dropIndex, 0, data.item)
    } else {
      dataSource.splice(dropIndex + 1, 0, data.item)
    }

    const newData = dataSource.filter((item) => item !== null)
    onChange(newData)
  }

  function saveImage(oldInfo: any, newInfo: any) {
    const newData = dataSource?.map((item) => {
      if (item.url && item.url === oldInfo.url) {
        return {
          ...item,
          url: newInfo.url,
        }
      }
      return item
    })
    onChange?.(newData)
  }

  return (
    <CustomReactDndProvider>
      <div className={Style.fileimgbox}>
        <div className={Style.fileimglist}>
          {dataSource.map((item, index) => {
            const key = isDetailPic
              ? item?.url
              : `${item?.baseUrl ? item?.baseUrl : HTTP}${item?.url}`
            const originImgUrl = getOriginImageUrl(item)
            const imageItem = (
              <ImageItem
                item={item}
                index={index}
                key={item.url}
                onClickDel={onClickDel}
                onClickPreview={onClickPreview}
                onInsertData={handleInsertData}
                dragable={dataSource.length > 1 && dragable}
                disable={disable}
                componentID={componentIDMemo}
              />
            )
            if (aiEdit) {
              return (
                <Popover
                  getPopupContainer={() => document.body}
                  content={
                    <Space>
                      <AiKoutuButton
                        originImgUrl={originImgUrl}
                        imageInfo={item}
                        // productCode={productCode}
                        onSaveKoutu={async (oldUrl, newUrl, options) => {
                          const { oldInfo, newInfo } = options
                          saveImage(oldInfo, newInfo)
                        }}
                      ></AiKoutuButton>
                      <AiPsButton
                        originImgUrl={originImgUrl}
                        imageInfo={item}
                        // productCode={productCode}
                        onSave={async (newInfo) => {
                          await saveImage(item, newInfo)
                        }}
                      ></AiPsButton>
                      <AiFaceBlurButton
                        originImgUrl={originImgUrl}
                        imageInfo={item}
                        // productCode={productCode}
                        onSaveFaceBlur={async (oldUrl, newUrl, options) => {
                          const { oldInfo, newInfo } = options
                          saveImage(oldInfo, newInfo)
                        }}
                        type={isDetailPic ? 'detailsPicture' : 'mainPicture'}
                      ></AiFaceBlurButton>
                    </Space>
                  }
                  key={key}
                  placement="top"
                >
                  <div className="w-[80px]"></div>
                  {imageItem}
                </Popover>
              )
            }
            return imageItem
          })}
          {disable || dataSource.length >= maxCount ? null : (
            <Customupload
              accept={fileType ?? ACCEPT_FILE_TYPE}
              multiple
              uploadBtn={
                <div
                  className={Style.uploadBtn}
                  style={{ backgroundImage: `url(${imgUpload})` }}
                ></div>
              }
              beforeUpload={(a, b) => beforeUpload(a, b)}
              visibleFile={false}
            />
          )}

          <Custompreviewimg
            onClose={() =>
              setPreviewimg({
                data: [],
              })
            }
            images={previewimg}
          />
        </div>
        <Tooltip
          placement="top"
          title={aiAuditErrorReasonForField?.join('\n')}
          overlayClassName={DetailStyle['custom-tooltip']}
          getPopupContainer={() => document.body}
        >
          {aiAuditErrorReasonForField?.map((i: any, index: number) => (
            <Typography.Text style={{ color: '#F57F17' }} ellipsis key={index}>
              {i}
            </Typography.Text>
          ))}
        </Tooltip>
      </div>
    </CustomReactDndProvider>
  )
}

export default Uploadimg
